import React from 'react';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { PaymentServiceItem } from './crm-payment-service-item.type';

interface PaymentServiceItemsEditorProps {
  items: PaymentServiceItem[];
  setItems: React.Dispatch<React.SetStateAction<PaymentServiceItem[]>>;
  loading: boolean;
  totalServicesAmount: number;
  onAddCatalogService?: () => void;
}

export const PaymentServiceItemsEditor: React.FC<
  PaymentServiceItemsEditorProps
> = ({
  items,
  setItems,
  loading,
  totalServicesAmount,
  onAddCatalogService,
}) => {
  return (
    <div>
      {items.map((item, idx) => {
        const isCatalog = item.kind === 'catalog';
        return (
          <div
            key={idx}
            style={{
              border: '1px solid var(--surface-200)',
              borderRadius: '8px',
              padding: '12px',
              background: 'var(--surface-0)',
              marginBottom: '0.75rem',
            }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '8fr 1fr 1fr auto',
                gap: '0.75rem',
                alignItems: 'end',
              }}
            >
              <div className="p-field">
                <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                  שם שירות *
                  {isCatalog ? (
                    <span
                      style={{
                        marginInlineStart: '0.5rem',
                        fontSize: '0.7rem',
                        fontWeight: 600,
                        color: '#64748b',
                        background: '#e2e8f0',
                        padding: '0.15rem 0.45rem',
                        borderRadius: '4px',
                      }}
                    >
                      משירותי תשלום
                    </span>
                  ) : null}
                </label>
                <InputText
                  value={item.serviceName}
                  onChange={(e) =>
                    setItems((prev) =>
                      prev.map((it, i) =>
                        i === idx && it.kind === 'adHoc'
                          ? { ...it, serviceName: e.target.value }
                          : it,
                      ),
                    )
                  }
                  style={{ width: '100%', minWidth: '200px' }}
                  disabled={loading || isCatalog}
                />
              </div>
              <div className="p-field">
                <label
                  style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                  }}
                >
                  כמות *
                </label>
                <InputNumber
                  value={item.units}
                  onValueChange={(e) =>
                    setItems((prev) =>
                      prev.map((it, i) =>
                        i === idx ? { ...it, units: e.value ?? null } : it,
                      ),
                    )
                  }
                  min={1}
                  useGrouping={false}
                  inputStyle={{ maxWidth: '120px' }}
                  style={{ width: '100%', maxWidth: '120px' }}
                  disabled={loading}
                />
              </div>
              <div className="p-field">
                <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                  מחיר ליחידה *
                </label>
                <InputNumber
                  value={item.unitPrice}
                  onValueChange={(e) =>
                    setItems((prev) =>
                      prev.map((it, i) =>
                        i === idx && it.kind === 'adHoc'
                          ? { ...it, unitPrice: e.value ?? null }
                          : it,
                      ),
                    )
                  }
                  mode="currency"
                  currency="ILS"
                  locale="he-IL"
                  min={0}
                  maxFractionDigits={2}
                  style={{ width: '100%', direction: 'ltr' }}
                  inputStyle={{
                    direction: 'rtl',
                    textAlign: 'right',
                    maxWidth: '120px',
                  }}
                  disabled={loading || isCatalog}
                />
              </div>
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                onClick={() =>
                  setItems((prev) => prev.filter((_, i) => i !== idx))
                }
                disabled={loading || items.length === 1}
                tooltip={
                  items.length === 1 ? 'חייב להיות לפחות פריט אחד' : 'מחיקה'
                }
              />
            </div>
            <div style={{ marginTop: '10px', color: '#6b7280' }}>
              סה״כ פריט:{' '}
              {(
                (typeof item.units === 'number' ? item.units : 0) *
                (typeof item.unitPrice === 'number' ? item.unitPrice : 0)
              ).toFixed(2)}
            </div>
          </div>
        );
      })}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
          <Button
            label="הוסף שירות"
            icon="pi pi-plus"
            onClick={() =>
              setItems((prev) => [
                ...prev,
                { kind: 'adHoc', serviceName: '', units: 1, unitPrice: null },
              ])
            }
            disabled={loading}
            severity="secondary"
            outlined
          />
          {onAddCatalogService ? (
            <Button
              label="הוסף שירות משירותי תשלום"
              icon="pi pi-list"
              onClick={onAddCatalogService}
              disabled={loading}
              severity="secondary"
              outlined
            />
          ) : null}
        </div>
        <div
          style={{
            display: 'flex',
            gap: '0.5rem',
            alignItems: 'center',
            fontWeight: 700,
            fontSize: '1rem',
          }}
        >
          <span>סה״כ לתשלום:</span>
          <span>{totalServicesAmount.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};
